<template>
  <main class="repayment-list order-list-common">
    <section class="content-wrapper">
      <div
        v-if="tableData && tableData.length"
        class="repay-order"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <header class="list-head">
          <span>借款单号: {{ item.loanOrderId }}</span>
          <span>申请日期: {{ item.loanOrderTime }}</span>
          <span>申请人: {{ item.tenantName }}</span>
          <!-- <p class="warn-info"><el-tag type="warning"><i class="el-icon-warning"></i>您有1笔提前还款失败</el-tag></p> -->
        </header>
        <div class="list-info" v-if="item.loanStatus !== 50">
          <i style="width:50px;display:block"></i>
          <p class="repay-common">
            <span>借款总额（元）</span>
            <span class="moneny">{{ $utils.toYuan(item.loanAmount) }}</span>
          </p>
          <!-- <b class="agree-btn">签署合同</b> -->
          <p
            class="repay-common"
            v-if="item.loanStatus !== 30 && item.loanStatus !== 35"
          >
            <span class="repaid-moneny">{{ item.loanStatusName }}</span>
          </p>
          <p class="repay-common" v-if="item.loanStatus == 30">
            <b
              class="agree-btn"
              style="cursor:pointer"
              @click.stop="signContract(item.loanOrderId)"
              >签署合同</b
            >
          </p>
          <p></p>
          <p class="repay-common" v-if="item.loanStatus === 35">
            <b class="agree-btn signing">签署中</b>
          </p>
          <span class="repay-detail" @click.stop="checkDetail(item.loanOrderId)"
            >查看详情</span
          >
        </div>
        <el-collapse ref="collapse" v-if="item.loanStatus === 50">
          <el-collapse-item name="">
            <template slot="title">
              <div class="list-info" style="padding: 28px 60px">
                <p class="repay-common">
                  <span>借款总额（元）</span>
                  <span class="moneny">{{
                    $utils.toYuan(item.loanAmount)
                  }}</span>
                </p>
                <!-- <p class="repay-common">
                  <span>还款状态(元)</span>
                  <span class="repaid-moneny"><span class="money">已还50000 | 待还500000</span><span class="overdue-status">已逾期</span></span>
                </p> -->
                <p
                  class="repay-common"
                  v-if="item.loanStatus !== 30 && item.loanStatus !== 35"
                >
                  <span class="repaid-moneny">{{ item.loanStatusName }}</span>
                </p>
                <p class="repay-common" v-if="item.loanStatus == 30">
                  <b
                    class="agree-btn"
                    style="cursor:pointer"
                    @click.stop="signContract(item.loanOrderId)"
                    >签署合同</b
                  >
                </p>
                <p class="repay-common" v-if="item.loanStatus === 35">
                  <b class="agree-btn signing">签署中</b>
                </p>
                <span
                  class="repay-detail"
                  @click.stop="checkDetail(item.loanOrderId)"
                  >查看详情</span
                >
              </div>
            </template>
            <div class="repay-order-list">
              <el-table :data="item.assets">
                <el-table-column prop="assetId" label="资产编号">
                </el-table-column>
                <el-table-column label="借款金额(元)">
                  <template slot-scope="scope">
                    {{ $utils.toYuan(scope.row.assetAmount) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span
                      class="repay-btn"
                      @click.stop="
                        openAdvanceRepayDialog({
                          assetId: scope.row.assetId,
                          loanOrderId: item.loanOrderId,
                        })
                      "
                      >提前还款</span
                    >
                    <span
                      class="repay-btn"
                      @click="openRepayPlanDialog(scope.row.assetId)"
                      >还款计划</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="no-data" v-if="!tableData.length">
        <p class="img-wrapper">
          <img src="../../../assets/images/orange-loan/no-bill.png" alt="" />
          <span class="nobill-info">您暂无借款</span>
        </p>
      </div>
    </section>
  </main>
</template>
<script>
export default {
  created() {
    this.getRepayList()
  },
  data() {
    return {
      // activeNames: '1'
    }
  },
  computed: {
    tableData() {
      return this.$store.state.loan.loanList
    },
  },
  methods: {
    getRepayList() {
      this.$store.dispatch('loan/GET_LOAN_LIST', {
        pageSize: 10000,
      })
    },
    openAdvanceRepayDialog(item) {
      this.$store.dispatch('loan/ADVANCE_PLAN_QUERY', {
        assetId: item.assetId,
      })
      this.$emit('openAdvanceRepayDialog', item)
    },
    openRepayPlanDialog(assetId) {
      this.$store.dispatch('loan/GET_REPAY_PLAN', {
        assetId,
      })
      this.$emit('openRepayPlanDialog')
    },
    checkDetail(loanOrderId) {
      this.$emit('checkDetail', loanOrderId)
      this.$store.dispatch('loan/GET_CUSTOMER_INFO')
      this.$store.dispatch('loan/GET_LOAN_LIST', {
        pageSize: 1,
        loanOrderId: loanOrderId,
        showDialog: true,
      })
    },
    signContract(loanOrderId) {
      this.$request({
        url: '/proxy/oneCar/api/loan/contract/sign/apply',
        method: 'post',
        data: {
          loanOrderId,
        },
      }).then((res) => {
        if (!res.errorCode) {
          this.$message({
            message: '签署合同申请已发送!',
            type: 'success',
          })
          this.getRepayList()
        } else {
          this.$message.error(res.errorMsg)
        }
      })
    },
  },
}
</script>
<style lang="stylus">
@import '../../../assets/css/common-color.styl'
.el-collapse
  border none
  .el-collapse-item__header
    height 110px
    padding-left 24px
    border-bottom 1px solid #DCDFE6
    .el-collapse-item__arrow
      float left
      margin-top 30px
      font-size 18px
.repayment-list,.order-list-common
  .content-wrapper
    .no-data
      margin-top 147px
      .img-wrapper
        display flex
        align-items center
        justify-content center
        flex-direction column
        img
          width 160px
          height 160px
        .nobill-info
          font-size 16px
          color gray03
    .repay-order
      margin-top 20px
      border 1px solid #dcdfe6
      .list-head
        height 48px
        line-height 44px
        background #F4F5F7
        padding 0 24px
        .warn-info
          float right
        span
          margin-right 40px
          font-family PingFangSC-Regular
          font-size 12px
          color gray02
          line-height 14px
      .list-info
        padding 28px 60px
        box-sizing  border-box
        display flex
        justify-content center
        align-items center
        box-sizing border-box
        .agree-btn
          height 28px
          font-size 14px
          color primary-color
          padding 4px 8px
          border 1px solid primary-color
          line-height 28px
          border-radius 4px
          width 88px
          text-align center
        .signing
          border 1px solid gray05
          color gray05
        .repay-common
          font-size 12px
          color gray02
          display flex
          flex-direction column
          justify-content space-around
          align-items center
          flex 2
          text-align center
          .overdue-status
            height 14px
            background #FF5B60
            font-size 12px
            padding 2px
            border-radius 2px
            color white
            margin-left 4px
            float right
            line-height 14px
          span
            font-size 14px
            color gray02
            display block
            text-align center
            height 20px
            line-height 20px
          .moneny
            font-size 24px
            font-family DINPro
            color gray01
        .repaid-moneny
          font-size 14px
          flex 1
          text-align center
          .money
            float left
        .repay-detail
          color link-color
          font-size 14px
          line-height 40px
          cursor pointer
          flex 1
          text-align center
      .repay-order-list
        padding 20px 125px
        .repay-btn
          color primary-color
          cursor pointer
          margin-right 36px
  .el-table td,.el-table th.is-leaf,.el-table--border, .el-table--group
    border none
  .el-table th.is-leaf
    border-bottom 1px dashed #DCDFE6
  .el-table--border::after, .el-table--group::after, .el-table::before
    background-color white
  .el-table thead
    color gray03
  tbody
    margin-top 25px
  .el-button--text
    font-size 14px
  .el-icon-warning
    font-size 14px
    color gray03
  .el-tag--warning
    background-color #FFF5F0
</style>
